import React from "react"
import { graphql } from "gatsby"

export const query = graphql`
  fragment ArticleContentImageFields on DatoCmsArticleBlockImage {
    id
    model {
      apiKey
    }
    file {
      height
      width
      url(imgixParams: { w: "1000" })
      fullWidthUrl: url(imgixParams: { w: "2000" })
      focalPoint {
        x
        y
      }
    }
    caption
    layout
  }
`

import { ArticleContentImageFieldsFragment } from "../../../../graphql-types"
import ImageSurface from "../../util/image-surface"

const ArticleBlockImage: React.FC<ArticleContentImageFieldsFragment> = props => {
  if (props.file && props.file.url) {
    const width = props.file.width > 1000 ? 1000 : props.file.width
    const height = Math.round((props.file.height / props.file.width) * width)
    const heightPercentage = Math.round(
      (props.file.height / props.file.width) * 100
    )
    const containerStyle =
      props.layout === "full_width"
        ? {
            height: heightPercentage.toString() + "vw",
          }
        : {}
    const imageElement =
      props.layout === "full_width" ? (
        <ImageSurface
          url={props.file.fullWidthUrl}
          focalPoint={props.file.focalPoint}
        ></ImageSurface>
      ) : (
        <img src={props.file.url} width={width} height={height} alt="" />
      )
    return (
      props.file &&
      props.file.url && (
        <figure
          className={`c-article-block-image -${props.layout}`}
          style={containerStyle}
        >
          {imageElement}
          {props.caption && (
            <figcaption className="o-wrapper">{props.caption}</figcaption>
          )}
        </figure>
      )
    )
  }
}

export default ArticleBlockImage
